import {AxiosRequestConfig} from 'axios';
import {JobTitleService} from './job-title.service';
import Logger from '../../logger';
import {JobTitle} from '../../models/work-experience.model';
import {getAuthToken} from '../../utils';
import {APIServiceImpl, ServiceResponse} from '../api';
import {JobTitleCreateParams} from './job-title-params';

export class JobTitleServiceImpl extends APIServiceImpl implements JobTitleService {
  static readonly CREATE_JOB_TITLE = '/accounts/:accountId/job-titles';
  static readonly GET_GLOBAL_JOB_TITLES = '/job-titles';

  constructor() {
    super();
    this.service.interceptors.request.use((request): AxiosRequestConfig => {
      const token = getAuthToken();
      token && (request.headers.Authorization = `Bearer ${token}`);
      return request;
    });
  }

  async createJobTitle(params: JobTitleCreateParams): Promise<ServiceResponse<JobTitle>> {
    const url = JobTitleServiceImpl.CREATE_JOB_TITLE.replace(':accountId', params.accountId);

    try {
      const {data: res} = await this.post(url, {
        title: params.title,
      });
      return new ServiceResponse<JobTitle>(new JobTitle(res));
    } catch (e) {
      const error = e.response?.data?.message || e.message || e.response?.status;
      Logger.error(`POST ${url} ${JSON.stringify(params)}: ${e.toString()}: ${error}`);
      return new ServiceResponse<JobTitle>(undefined, error);
    }
  }

  async getAllGlobalJobTitles(page: number = 1, limit: number = 10): Promise<ServiceResponse<{data: JobTitle[]; total: number}>> {
    const url = JobTitleServiceImpl.GET_GLOBAL_JOB_TITLES;

    try {
      const {data: res} = await this.get(url, {
        params: {
          page,
          limit,
        },
      });

      const jobTitles = res.data?.map((item: any) => new JobTitle(item)) || [];
      const total = res.total || 0;

      return new ServiceResponse<{data: JobTitle[]; total: number}>({
        data: jobTitles,
        total,
      });
    } catch (e) {
      const error = e.response?.data?.message || e.message || e.response?.status;
      Logger.error(`GET ${url} with page=${page}, limit=${limit}: ${e.toString()}: ${error}`);
      return new ServiceResponse<{data: JobTitle[]; total: number}>(undefined, error);
    }
  }
}
